"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var errRecordApi = _interopRequireWildcard(require("@/api/errRecordApi.js"));
var _errDetail = _interopRequireDefault(require("./errDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ErrDetail: _errDetail.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        keywords: null,
        cid: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
  },
  methods: {
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      errRecordApi.ListArticle(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    openRecord: function openRecord(row) {
      this.$refs['ErrDetailRef'].initOpen(row);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    }
  }
};